<template>
  <div id="footer_logo">
    <div>
      <a :href="cityWebsite" target="__blank">
        <img :src="logo" :alt="cityName" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-footer-logo',
  props: {
    cityName: String,
    cityWebsite: String,
    logo: String
  }
}
</script>

<style scoped>
  img {
    max-height: 8rem;
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/app-footer-city-logo.vue